import _slicedToArray from "/working_dir/frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toArray from "/working_dir/frontend/node_modules/@babel/runtime/helpers/esm/toArray.js";

function addUniqueItem(arr, item) {
  if (arr.indexOf(item) === -1) arr.push(item);
}

function removeItem(arr, item) {
  var index = arr.indexOf(item);
  if (index > -1) arr.splice(index, 1);
} // Adapted from array-move


function moveItem(_ref, fromIndex, toIndex) {
  var _ref2 = _toArray(_ref),
      arr = _ref2.slice(0);

  var startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;

  if (startIndex >= 0 && startIndex < arr.length) {
    var endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;

    var _arr$splice = arr.splice(fromIndex, 1),
        _arr$splice2 = _slicedToArray(_arr$splice, 1),
        item = _arr$splice2[0];

    arr.splice(endIndex, 0, item);
  }

  return arr;
}

export { addUniqueItem, moveItem, removeItem };